import { useTranslation } from "react-i18next";import React from 'react';
import { cn } from '@/shared/utils';
import {
  MapPin,
  Clock,
  CheckCircle,
  Camera,
  ChevronRight } from
'lucide-react';
import { Badge } from '@/shared/components/ui/badge';

// Single stop item - Uber Eats multi-stop style
const StopItem = ({ stop, index, totalStops, isActive, isCompleted, onClick }) => {
  const { t } = useTranslation("ezparcel");
  return (
<div
  className={cn(
    "relative flex items-start gap-3 cursor-pointer group",
    index < totalStops - 1 && "pb-4"
  )}
  onClick={() => onClick?.(stop)}
  data-testid={`stop-item-${stop.id}`}>
  
    {/* Connector line */}
    {index < totalStops - 1 &&
  <div className={cn(
    "absolute left-[15px] top-8 w-0.5 h-[calc(100%-16px)]",
    isCompleted ? "bg-emerald-300" : "bg-gray-200"
  )} />
  }
    
    {/* Stop number */}
    <div className={cn(
    "relative z-10 w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0 border-2 transition-all",
    isCompleted ?
    "bg-emerald-500 border-emerald-500 text-white" :
    isActive ?
    "bg-blue-500 border-blue-500 text-white animate-pulse" :
    "bg-white border-gray-300 text-gray-500"
  )}>
      {isCompleted ? <CheckCircle className="h-4 w-4" /> : index + 1}
    </div>
    
    {/* Stop details */}
    <div className={cn(
    "flex-1 rounded-lg p-3 transition-all",
    isActive ?
    "bg-blue-50 border border-blue-200" :
    "bg-gray-50 border border-transparent group-hover:border-gray-200"
  )}>
      <div className="flex items-start justify-between">
        <div>
          <h4 className="font-medium text-gray-900">{stop.name}</h4>
          <div className="flex items-center gap-3 mt-1 text-xs text-gray-500">
            <span className="flex items-center gap-1">
              <Clock className="h-3 w-3" />
              {stop.arrival} - {stop.departure}
            </span>
            <span className="flex items-center gap-1">
              <MapPin className="h-3 w-3" />
              {stop.duration}{t("min", "min")}
          </span>
          </div>
        </div>
        
        <div className="flex items-center gap-2">
          {stop.pod &&
        <Badge variant="outline" className="text-xs bg-cyan-50 text-cyan-700 border-cyan-200">
              <Camera className="h-3 w-3 mr-1" />{t("pod", "POD")}

        </Badge>
        }
          <Badge
          variant="outline"
          className={cn(
            "text-xs",
            stop.status === 'Delivered' ?
            "bg-emerald-50 text-emerald-700 border-emerald-200" :
            stop.status === 'In Progress' ?
            "bg-blue-50 text-blue-700 border-blue-200" :
            "bg-gray-50 text-gray-600 border-gray-200"
          )}>
          
            {stop.status}
          </Badge>
        </div>
      </div>
    </div>
  </div>
  );
};


export const StopsList = ({
  stops = [],
  currentStopIndex = 0,
  onStopClick,
  showHeader = true
}) => {const { t } = useTranslation("ezparcel");
  if (stops.length === 0) {
    return (
      <div className="text-center py-6 text-gray-500">
        <MapPin className="h-8 w-8 mx-auto mb-2 opacity-50" />
        <p className="text-sm">{t("noStopsIn", "No stops in this route")}</p>
      </div>);

  }

  return (
    <div className="bg-white rounded-xl border border-gray-200" data-testid="stops-list">
      {showHeader &&
      <div className="flex items-center justify-between p-4 border-b border-gray-100">
          <h3 className="font-semibold text-gray-900">{t("routeStops", "Route Stops")}</h3>
          <Badge variant="secondary" className="font-mono">
            {stops.length}{t("stops", "stops")}
        </Badge>
        </div>
      }
      
      <div className="p-4">
        {stops.map((stop, idx) =>
        <StopItem
          key={stop.id}
          stop={stop}
          index={idx}
          totalStops={stops.length}
          isActive={idx === currentStopIndex}
          isCompleted={idx < currentStopIndex}
          onClick={onStopClick} />

        )}
      </div>
    </div>);

};